import PropTypes from 'prop-types';
import { PillTypes, Resources } from './viewDiagnostics.constants';

const PaymentsAndTransfersPropType = PropTypes.shape({
  connName: PropTypes.string,
  companyCode: PropTypes.string,
  glAccount: PropTypes.string,
  tradingPartner: PropTypes.string,
  bookType: PropTypes.string,
  tbBalance: PropTypes.number,
  tbCurrencyCode: PropTypes.string,
});

const NonZeroBalancesPropType = PaymentsAndTransfersPropType;

const NonMatchingBalancesPropType = PropTypes.shape({
  connName: PropTypes.string,
  companyCode: PropTypes.string,
  glAccount: PropTypes.string,
  tradingPartner: PropTypes.string,
  bookType: PropTypes.string,
  tbBalance: PropTypes.number,
  tbCurrencyCode: PropTypes.string,
  tbBalanceMor: PropTypes.number,
  tbCurrencyCodeMor: PropTypes.string,
  slBalance: PropTypes.number,
  slCurrencyCode: PropTypes.string,
  diffBalance: PropTypes.number,
  diffCurrencyCode: PropTypes.string,
});

const NonMatchingBalancesSupportPropType = PropTypes.shape({
  connName: PropTypes.string,
  companyCode: PropTypes.string,
  slAccount: PropTypes.string,
  glAccount: PropTypes.string,
  tradingPartner: PropTypes.string,
  bookType: PropTypes.string,
  taxYear: PropTypes.string,
  countryTaxType: PropTypes.string,
  currencyCode: PropTypes.string,
  beginBalanceDebit: PropTypes.number,
  beginBalanceCredit: PropTypes.number,
  periodNetDebit: PropTypes.number,
  periodNetCredit: PropTypes.number,
  slBalance: PropTypes.number,
});

export const PaymentsAndTransfersPropTypes = PropTypes.arrayOf(PaymentsAndTransfersPropType).isRequired;
export const NonZeroBalancesPropTypes = PropTypes.arrayOf(NonZeroBalancesPropType).isRequired;
export const NonMatchingBalancesPropTypes = PropTypes.arrayOf(NonMatchingBalancesPropType).isRequired;
export const NonMatchingBalancesSupportPropTypes = PropTypes.arrayOf(NonMatchingBalancesSupportPropType).isRequired;

export const DiagnosticsPropTypes = PropTypes.shape({
  [Resources[PillTypes.PAYMENTS_TRANSFERS]]: PaymentsAndTransfersPropTypes,
  [Resources[PillTypes.NON_ZERO]]: NonZeroBalancesPropTypes,
  [Resources[PillTypes.NON_MATCHING]]: NonMatchingBalancesPropTypes,
  [Resources[PillTypes.NON_MATCHING_SUPPORT]]: NonMatchingBalancesSupportPropTypes,
});
